import React, { FC } from 'react';
import { Entry, EntryFields } from 'contentful';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Body } from '@sumup-oss/circuit-ui';

import { StyledCallout } from '../styled';

// eslint-disable-next-line import/no-cycle
import { CALLOUT_OPTIONS } from 'constants/richTextRendererOptions';

export type CalloutData = {
  name: string;
  type: string;
  title?: string;
  // Need to enforce type for body.nodeType
  // Otherwise, we get the below error
  // Type '"document"' is not assignable to type 'BLOCKS.DOCUMENT'. ts(2345)
  body: EntryFields.RichText & {
    nodeType: BLOCKS.DOCUMENT;
  };
};

type CalloutProps = {
  calloutData: Entry<CalloutData>;
};

const Callout: FC<CalloutProps> = ({ calloutData }) =>
  calloutData ? (
    <StyledCallout type={calloutData.fields?.type}>
      {calloutData.fields?.title ? (
        <Body size="m" as="strong">
          {calloutData.fields.title}
        </Body>
      ) : null}
      {documentToReactComponents(calloutData?.fields?.body, CALLOUT_OPTIONS)}
    </StyledCallout>
  ) : null;

export default Callout;
